import z from "zod";
import type { FormInputSchemaParams } from "@/lib/types/form/form-field";

export default function formSearchProfileZodSchema({ required }: FormInputSchemaParams) {
	const propertyType = required ? z.string().min(1, { message: "required" }) : z.string();

	return z.object({
		propertyType,
		rules: z.record(z.string(), z.unknown()).optional(),
	});
}
